module.exports = __webpack_public_path__ + "img/xls-file.1c5d4798.svg";